import { Button, Result } from 'antd';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSearchParams } from 'react-router-dom';
import { api } from '../../utils';
import { PdfModal2 } from './PdfModal2';

const UserAgreement = () => {
  const [confirm, setConfirm] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [open, setOpen] = useState(false);
  const [pdf, setPdf] = useState(false);
  const [searchParams] = useSearchParams();

  const fio = searchParams.get('fio');
  const identityDocument = searchParams.get('identityDocument');
  const driverLicense = searchParams.get('driverLicense');
  const vehiclePassport = searchParams.get('vehiclePassport');
  const vehicleMileage = searchParams.get('vehicleMileage');
  const exhaustEmissionData = searchParams.get('exhaustEmissionData');
  const jobId = searchParams.get('jobId');
  const moduleId = searchParams.get('moduleId');
  const region = searchParams.get('region');

  const getPDF = async () => {
    try {
      const res = await api.post(`/userAgreement/exists`, {
        fio,
        identityDocument,
        driverLicense,
        vehiclePassport,
        vehicleMileage,
        exhaustEmissionData,
        jobId,
        moduleId,
      });
      console.log(res.data);
      const exists = res.data;
      if (exists?.userAgreement) {
        setConfirmed(true);
        return;
      }
      setPdf(true);
    } catch (e: any) {
      if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
        return;
      }
      console.error(e);
      toast.error(e.message);
    }
  };

  useEffect(() => {
    getPDF();
  }, []);

  if (confirm)
    return (
      <Result
        status="success"
        title={
          <>
            <div>Тұтынушылық шарты сәтті қол қойылды</div>
            <div>Соглашение успешно подписано</div>
          </>
        }
      />
    );
  if (confirmed)
    return <Result status="success" title="Вы уже подписали пользовательское соглашение" />;

  return (
    <div>
      <Result
        title={
          <>
            Сатып алудан бұрын Пайдаланушы келісімін қарап шығыңыз және келісімді растаңыз. <br />
            Перед покупкой ознакомьтесь с пользовательским соглашением и подтвердите согласие.
          </>
        }
        extra={
          <>
            <div style={{ maxWidth: 500, textAlign: 'left', margin: '0 auto' }}>
              <h4>Сіздің деректеріңіз/Ваши данные:</h4>

              <p>- Көліктің техникалық құжаты (Техпаспорт автомобиля):</p>
              <p>{vehiclePassport}</p>

              <p>- Жүргізуші куәлігі (Водительское удостоверение):</p>
              <p>{driverLicense}</p>

              <p>- Көліктің жүріп өткен қашықтығы (км/миль) (Пробег (км/миль)):</p>
              <p>{vehicleMileage}</p>

              <p>- Өз мекеніңіз (Ваш регион):</p>
              <p>{region}</p>
            </div>

            {/*<Button type="primary" onClick={() => setOpen(true)} style={{marginTop: 20}}>*/}
            {/*  Пользовательское соглашение*/}
            {/*</Button>*/}

            <div style={{ position: 'relative', width: 300, height: 33, margin: '0 auto' }}>
              <Button
                color="primary"
                variant="text"
                onClick={() => {
                  setOpen(true);
                }}
                style={{
                  marginInlineEnd: 0,
                  position: 'absolute',
                  top: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                Тұтынушылық шарты/Пользовательское соглашение
              </Button>
            </div>

            <Button
              type="primary"
              onClick={async () => {
                try {
                  await api.post(`/userAgreement/generate`, {
                    fio,
                    identityDocument,
                    driverLicense,
                    vehiclePassport,
                    vehicleMileage,
                    exhaustEmissionData,
                    jobId,
                    moduleId,
                  });
                  setConfirm(true);
                } catch (e) {
                  toast.error('Не удалось принять соглашение. Повторите попытку.');
                }
                setOpen(false);
              }}
              style={{ margin: '0 auto', marginTop: 12, display: 'block', width: 300 }}
            >
              Қол қою/Подписать
            </Button>

            <p style={{ marginTop: 16, opacity: 0.6 }}>
              Төлем жасай отырып, сіз осы Шарттың талаптарымен келісетіндігіңізді растайсыз
            </p>
            <p style={{ marginTop: 4, opacity: 0.6 }}>
              Производя оплату, вы подтверждаете своё согласие с условиями данного договора
            </p>
          </>
        }
      />

      {pdf && (
        <PdfModal2
          open={open}
          onClose={() => setOpen(false)}
          data={{
            fio,
            identityDocument,
            driverLicense,
            vehiclePassport,
            vehicleMileage,
            exhaustEmissionData,
            jobId,
            moduleId,
          }}
          onConfirm={async () => {
            try {
              await api.post(`/userAgreement/generate`, {
                fio,
                identityDocument,
                driverLicense,
                vehiclePassport,
                vehicleMileage,
                exhaustEmissionData,
                jobId,
                moduleId,
              });
              setConfirm(true);
            } catch (e) {
              toast.error('Не удалось принять соглашение. Повторите попытку.');
            }
            setOpen(false);
          }}
        />
      )}
    </div>
  );
};
export default UserAgreement;
